import React from 'react'
import { Button } from '@fs/zion-ui'
import { useHelpOverlay } from '@fs/zion-help-overlay'
import { useTranslation } from 'react-i18next'

const HelpOverlayLearnMore = ({ helpActionUrl }) => {
  const [t] = useTranslation()
  const helpOverlay = useHelpOverlay(helpActionUrl)

  return (
    <Button
      ref={helpOverlay.targetRef}
      onClick={(e) => {
        e.stopPropagation()
        helpOverlay.handleClick()
      }}
    >
      {t('add-person.learn-more', 'Learn More')}
    </Button>
  )
}

export default HelpOverlayLearnMore
